module.exports = __webpack_public_path__ + "img/files.1941c876.svg";